var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReferral(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.188 6.055h-2.883c.265-.418.422-.914.422-1.446A2.692 2.692 0 0010 2.84a2.692 2.692 0 00-4.727 1.77c0 .532.155 1.028.422 1.446H2.812a.624.624 0 00-.624.625v3.906c0 .086.07.156.156.156h.781v6.719c0 .346.28.625.625.625h12.5c.346 0 .625-.28.625-.625v-6.719h.781c.086 0 .157-.07.157-.156V6.68a.624.624 0 00-.625-.625zm-6.524-1.446c0-.754.613-1.367 1.367-1.367s1.367.613 1.367 1.367-.613 1.368-1.367 1.368h-1.367V4.609zM7.97 3.242c.754 0 1.367.613 1.367 1.367v1.368H7.969a1.369 1.369 0 01-1.367-1.368c0-.754.613-1.367 1.367-1.367zM3.516 9.414V7.383h5.82v2.031h-5.82zm.937 1.328h4.883v6.016H4.453v-6.016zm11.094 6.016h-4.883v-6.016h4.883v6.016zm.937-7.344h-5.82V7.383h5.82v2.031z",
    fill: "#BFBFBF"
  })));
}

export default __webpack_public_path__ + "./fonts/Referral.18c4ae977ad702ebd3d0adb1e1cf8d80.svg";
export { SvgReferral as ReactComponent };